import React, {useState} from 'react';
import {selectLang} from "../../../store/reducers/main/main";
import {useSelector} from "react-redux";
import {Translate} from "../../../lang/lang";
import {Tab, Tabs} from "react-bootstrap";
import Charge from "./Charge";
import BillingCards from "./BillingCards";
export const CHARGES = '1'
export const EXPENSES = '2'
const OtherTab = () => {
    const [key, setKey] = useState(CHARGES);
    const lang = useSelector(selectLang);
    const t = Translate;


    return (
        <Tabs activeKey={key} fill onSelect={key => setKey(key)} className='border-bottom p-3 pb-0 nav-underline'>
            <Tab className="" eventKey={CHARGES} title={t(lang, 'main.billing.tabs.other.expenses.title')}>
                <Charge tab={key}/>
            </Tab>
            <Tab className="" eventKey={EXPENSES} title={t(lang, 'main.billing.tabs.other.payment.and.operation.title')}>
                <BillingCards tab={key}/>
            </Tab>
        </Tabs>
    );
};

export default OtherTab;
